// extracted by mini-css-extract-plugin
export default {"question-metadata":"Metadata_question-metadata__wCBiP"};